import Link from "next/link";
import { PUBLIC_PRICING_CARDS } from "~/lib/siteglue/public-pricing";
import { cn } from "~/lib/utils";

export function PublicPricingCards({
  className,
  testId = "public-pricing-cards",
}: {
  className?: string;
  testId?: string;
} = {}) {
  return (
    <div data-testid={testId} className={cn("grid gap-4 md:grid-cols-3", className)}>
      {PUBLIC_PRICING_CARDS.map((card) => (
        <div
          key={card.id}
          data-testid={`pricing-card-${card.id}`}
          className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-5"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#4f81bd]">{card.eyebrow}</p>
          <h2 className="mt-2 text-lg font-semibold text-slate-900">{card.title}</h2>
          <p className="mt-1 text-2xl font-bold text-slate-900">{card.priceLabel}</p>
          <p className="mt-2 text-sm text-slate-600">{card.headline}</p>
          <p
            className={cn(
              "mt-3 text-xs font-semibold uppercase tracking-[0.12em]",
              card.planned ? "text-amber-700" : "invisible text-amber-700",
            )}
          >
            Planned features labeled
          </p>
          <ul className="mt-4 flex-1 space-y-2 text-sm text-slate-700">
            {card.features.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
          <Link
            href={card.href}
            className="mt-6 inline-flex h-11 items-center justify-center rounded-full bg-[#4f81bd] px-5 text-sm font-semibold text-white hover:opacity-95"
          >
            {card.ctaLabel}
          </Link>
        </div>
      ))}
    </div>
  );
}
